import {
  findEmployeesWithFields,
  deleteUploadingEmployees,
} from "../../infrastructure/employees-cache";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { hideModal } from "../commons/hide-modal";
import { displayUploadEmployeesPage } from "./displays/display-upload-employees-page";
import { showErrorMessage } from "../commons/show-error-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function removeUploadingEmployees(
  employees,
  currentPage = 1,
  state
) {
  try {
    const companyId = await findCompanyId();
    const allEmployees = await findEmployeesWithFields({ companyId });
    const notRemovedEmployees = allEmployees.filter(
      (e) => e.state !== "removed"
    );

    const currentEmployees = notRemovedEmployees.filter(
      (e) => e.state === "uploading"
    );

    const employeeIds = currentEmployees.map(({ id }) => id);

    if (employeeIds.length > 0) {
      deleteUploadingEmployees({ employeeIds: employees, companyId }).then(() =>
        displayUploadEmployeesPage(currentPage, state)
      );
    }

    hideModal();
  } catch (e) {
    logError(e, `Error to removeUploadingEmployees`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
